import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { hero } from '../mockData';
import { Button } from '../components/ui/button';

const Home = () => {
  const { language } = useLanguage();
  const t = hero[language];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section relative min-h-screen flex items-center">
        {/* Background */}
        <div className="hero-background">
          <img
            src="https://images.unsplash.com/photo-1514306191717-452ec28c7814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzY5NDgxNjQzfDA&ixlib=rb-4.1.0&q=85"
            alt="Theater curtain"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-8 relative z-10">
          <div className="max-w-4xl">
            <h1 className="hero-title mb-6 animate-fade-in">
              {t.tagline}
            </h1>
            <p className="body-large text-white/90 mb-12 max-w-2xl animate-fade-in" style={{ animationDelay: '0.2s' }}>
              {t.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{ animationDelay: '0.4s' }}>
              <Link to="/submissions">
                <Button size="lg" className="btn-primary group">
                  {t.ctaPrimary}
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/about">
                <Button size="lg" variant="outline" className="btn-secondary">
                  {t.ctaSecondary}
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-gold/50 rounded-full flex justify-center pt-2">
            <div className="w-1 h-3 bg-gold/50 rounded-full"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;